export default __webpack_public_path__ + "static/media/step2.2c363a35.jpg";